import React from 'react'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
import CreatePlanModal from 'components/Modals/CreatePlanModal'
// constants
import { Modals } from 'constants/modals'
// hooks
import { useShowModal } from 'hooks/index'

const CreatePlanButton: React.FC = () => {
  const { showModal } = useShowModal({ modalType: Modals.PLAN_CREATE_MODAL })

  const showPlanCreateModal = () => showModal()

  return (
    <>
      <Button layout={BUTTON_LAYOUTS.PURPLE} onClick={showPlanCreateModal} style={CREATE_BUTTON_STYLE}>
        Create Plan
      </Button>

      <CreatePlanModal />
    </>
  )
}

export default CreatePlanButton
